import { config } from 'config'
import { requestAPI } from 'utils/api'

export const readAdminUsers = () => {
  return requestAPI({
    method: 'GET', url: '/etc/adminusers'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateAdminRole = (adminId: number, params: { role: string, has_bi_access: any }) => {

  return requestAPI({
    method: 'PATCH', url: `/etc/adminusers/${adminId}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => {
    throw JSON.parse(error)
  }).finally(() => {
    return Promise.all(config.commonURL.map((url: string) => {
      return requestAPI({
        method: 'PATCH', url: `${url}/etc/dbadminusers/${adminId}`, params
      })
    }))
  })
}

export const deleteAdmin = (adminId: number) => {
  return requestAPI({
    method: 'DELETE', url: `/etc/adminusers/${adminId}`
  }).then((result) => {
    return result.data
  }).catch((error) => {
    throw JSON.parse(error)
  }).finally(() => {
    return Promise.all(config.commonURL.map((url: string) => {
      return requestAPI({
        method: 'DELETE', url: `${url}/etc/dbadminusers/${adminId}`
      })
    }))
  })
}

export const readAdminActionLogs = (params: { start_time: any, end_time: any }) => {
  return requestAPI({
    method: 'GET', url: '/etc/adminlogs', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readTesterAccounts = () => {
  return requestAPI({
    method: 'GET', url: '/etc/testeraccount'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createTesterAccount = (params: any) => {
  return requestAPI({
    method: 'POST', url: `/etc/testeraccount/create`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateTesterAccountLogs = (id: any) => {
  return requestAPI({
    method: 'PATCH', url: `/etc/testeraccount/updatelogs/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteTesterAccount = (id: any) => {
  return requestAPI({
    method: 'PATCH', url: `/etc/testeraccount/delete/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}